export default class {
  static get depth() {
    return 1000;
  }
}